import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment, Confirm_button } from '../../../environments/environment';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { OAuthLoginMessage, CheckAuthOtpErrMsg, AuthOtpType, OAuthPurposeType, OAuthPlatformType } from '../../shareModel';
import { AccountOauthParam, OauthLoginParam } from '../../my-features/account/oauth.model';
import { AccountService } from '../../services/account.service';
import { UserService } from '../../services/user.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  standalone: false,
  selector: 'app-sso',
  templateUrl: './sso-callback.component.html',
  styleUrls: ['./sso-callback.component.css']
})
export class SSOCallbackComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  LoginLocked = false;
  LoginLockedMessage: string;
  loginFail = false;
  isLogging = false;
  socialEmailRegisterAlert = false;
  SSOAccountNotTheSameAlert = false;
  AddOauthparam: AccountOauthParam = {
    Code: '',
    RegisterSys: 1,
    RegisterType: 0,
    Purpose: OAuthPurposeType.AddAccountFromWeb,
    Country: ''
  };
  Confirm_button = Confirm_button;
  userEmail: string;
  Country: string;
  RegionId: number;
  MSPRegionId: number;
  TwoFactorAuthDialog = false;
  dialogSaveDirty = false;
  OTPOvertime = false;
  OTPNumberSubmitDisabled = true;
  AuthOtpId: number;
  AuthOtp: number;
  AuthUserotp: string;
  OTPNumber: string;
  errorMsg = '';
  OTPLockDialog = false;
  message: string;
  errorMsgByLock = false;
  config = {
    leftTime: 300,
    template: '$!m!:$!s!',
  };

  public form: FormGroup;
  socialType: string;
  inputType = 'password';
  showPasswordIcon: Boolean = false;
  constructor(private fb: FormBuilder,
    private store: Store<fromStore.State>,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private userService: UserService,
    private utils: UtilsService) {
      router.events.subscribe(s => {
        if (s instanceof NavigationEnd) {
          if (s.url.indexOf('?') !== -1) {
            const params = new URLSearchParams(s.url.split('?')[1]);
            // SSO
            const ssoUser = params.get('ssouser');
            if (ssoUser) {
              const decodeuser = decodeURIComponent(atob(ssoUser));
              const user = JSON.parse(decodeuser);
              this.userEmail = user.email;
              this.Country = user.country;
              this.RegionId = user.regionid;
              this.MSPRegionId = user.mspregionid;
              const token = JSON.parse(this.utils.getToken());
              const ssocookie = (token && token.ssocookie) ? token.ssocookie : '';
              if (this.userEmail.toLowerCase() === ssocookie.toLowerCase()) {
                const SSOId = user.id;
                const firstname = user.firstname;
                const lastname = user.lastname;

                const loginParam: OauthLoginParam = {
                  Platform: OAuthPlatformType.SSO,
                  PId: SSOId,
                  Email: this.userEmail,
                  WithDevice: true,
                  Code: '',
                  FirstName: (firstname) ? firstname : this.userEmail.split('@')[0],
                  LastName: (lastname) ? lastname : '',
                  Purpose: OAuthPurposeType.LoginOauth
                };
                this.store.dispatch(new fromFeature.GetOauthLogin(loginParam));
                // remove redirect param
                window.history.pushState({}, document.title, '/login/sso/callback' );
              } else {
                this.alertSSOAccountNotTheSame();
              }
            }
          }
        }
      });
      this.store.select(fromStore.getCurrentUser)
      .subscribe(res => {
        if (res.isLoading) {
          this.isLogging = true;
        } else {
          this.isLogging = false;
          // this.ngxService.stop();
        }
        const pathname = window.location.pathname;
        if (!res.isLoading && res.isLoaded && res.isLogin && pathname === '/login/sso/callback') {
          // tslint:disable-next-line:max-line-length
          if (this.userService.GetRedirect !== 'null' && this.userService.GetRedirect !== null && this.userService.GetRedirect !== '/' && this.userService.GetRedirect !== '/index' && this.userService.GetRedirect !== pathname) {
            this.router.navigate([this.userService.GetRedirect]);
          } else {
            this.router.navigate(['/index']);
          }
        } else if (!res.isLogin && res.isLoaded && !res.isLoading) {
          this.loginFail = true;
          if (res.Message && res.Message.includes('lock')) {
            this.LoginLockedMessage = res.Message;
            this.LoginLocked = true;
          }
        }
      });
      this.store.select(fromStore.getOauthLogin).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        if (res.Loading && !res.Loaded) {
          this.ngxService.start();
        }
        if (res.Loaded && !res.Loading) {
          this.ngxService.stop();
          if (!res.entities.Flag) {
            if (Number(res.entities.Message) === OAuthLoginMessage.AddAccountAvailable) {
              this.AddOauthparam = {
                ...this.AddOauthparam,
                Platform: res.entities.Platform,
                PId: res.entities.PId,
                Email: res.entities.Email,
                FirstName: res.entities.FirstName,
                LastName: res.entities.LastName,
                // this.socialEmailRegisterAlert = true;
                // this.registerAccountWithSocial();
                Country: this.Country,
                RegionId: this.RegionId,
                MSPRegionId: this.MSPRegionId,
              };
              this.store.dispatch(new fromFeature.AddAccountByOauth({ ...this.AddOauthparam }));
              this.ngxService.start();
            }
            if (res.entities.Message && res.entities.Message.toString().includes('lock')) {
              this.LoginLockedMessage = res.entities.Message.toString();
              this.LoginLocked = true;
            }
          }
        }
      });

      this.store.select(fromStore.getAuthotp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
        if (res.Loaded && !res.Loading) {
          if (res.entities !== undefined) {
            if (res.entities.Flag) {
              this.TwoFactorAuthDialog = true;
              this.dialogSaveDirty = false;
              this.OTPOvertime = false;
              this.OTPNumberSubmitDisabled = true;
              this.AuthOtpId = res.entities.Id;
              this.AuthUserotp = res.entities.otp;
              this.OTPNumber = '';
              this.errorMsg = '';
            } else {
              this.OTPLockDialog = true;
            }
          }
          this.ngxService.stop();
        } else if (!res.Loaded && res.Loading) {
          if (res.entities !== undefined) {
            this.message = res.entities.message;
          }
        }
      });
      this.store.select(fromStore.getCheckAuthOtp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
        if (res.Loaded && !res.Loading) {
          if (res.entities.Flag) {
          } else {
            this.errorMsg = CheckAuthOtpErrMsg[res.entities.Message];
            if (res.entities.Message === '1' || res.entities.Message === '2') {
              this.OTPOvertime = true;
              if (res.entities.Message === '1') {
                this.errorMsgByLock = true;
              }
              this.ngxService.stop();
            }
            this.dialogSaveDirty = true;
            this.ngxService.stop();
          }
        }
      });
   }

  ngOnInit() { }

  handleChange(e: any) {
    const isChecked = e.checked;
    if (isChecked) {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  handleEvent(e) {
    if (e.left <= 0) {
      this.errorMsg = CheckAuthOtpErrMsg[2];
      this.OTPOvertime = true;
    }
  }

  alertSSOAccountNotTheSame() {
    this.SSOAccountNotTheSameAlert = true;
  }

  closeDialog() {
    this.isLogging = false;
    this.LoginLocked = false;
    this.SSOAccountNotTheSameAlert = false;
    this.TwoFactorAuthDialog = false;
    this.router.navigate(['/login/sso']);
  }

  OTPkeyupEnter(e) {
    if (this.OTPNumber.length >= 6) {
      this.confrimOTPnumber();
    }
  }

  OTPNumberOnchange($event) {
    const OTPNumberLength = $event.replaceAll('_', '');
    if (OTPNumberLength.length >= 6) {
      this.OTPNumberSubmitDisabled = false;
    } else {
      this.OTPNumberSubmitDisabled = true;
    }
  }

  confrimOTPnumber() {
    this.ngxService.start();
    const param = {
      otp: this.AuthUserotp,
      authId: Number(this.AuthOtpId),
      authType: AuthOtpType.Login,
      authOtp: this.OTPNumber,
    };
    this.store.dispatch(new fromFeature.CheckAuthOtp(param));
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
